import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

import { PaystubsYear } from "./types";

const PARAMETER_PAYSTUB_ID = "paystubId";

const PAYSTUBS_PATH = "/member/paystubs";
const PAYSTUBS_DASHBOARD_PATH = `${PAYSTUBS_PATH}/:year`;
const PAYSTUBS_DETAILS_PATH = `${PAYSTUBS_DASHBOARD_PATH}/paystub/:${PARAMETER_PAYSTUB_ID}`;

export const routeHelperPaystubs = createRouteHelpers(PAYSTUBS_PATH);

type PaystubsDashboardParams = {
  year: PaystubsYear;
};

export const routeHelperPaystubsDashboard =
  createRouteHelpers<PaystubsDashboardParams>(PAYSTUBS_DASHBOARD_PATH);

type PaystubsDetailsParams = PaystubsDashboardParams & {
  paystubId: string;
};

export const routeHelperPaystubsDetails =
  createRouteHelpers<PaystubsDetailsParams>(PAYSTUBS_DETAILS_PATH);
